import { ml, TopMenuItem } from '@openeducation/oe-it-components';
import {
  useLoginContext,
  usePortalNavigationContext,
} from '@openeducation/oe-it-providers';
import { Linking } from 'react-native';
import { useTheme } from 'react-native-paper';

import { useRedirectTo } from './use-redirect-to';
import { PortalPaths } from '../interfaces/portal-paths.enum';

const appPages = [
  { name: 'Dashboard', path: PortalPaths.Dashboard },
  { name: 'Messages', path: PortalPaths.Messages },
  { name: 'Account', path: PortalPaths.Account },
  { name: 'Private Class', path: PortalPaths.PendingFeedbacks, newTab: true },
];

export function usePageLinks(selectedPage?: PortalPaths) {
  const { logout } = useLoginContext();
  const { redirectTo } = useRedirectTo();

  const { navigate } = usePortalNavigationContext();
  const { colors } = useTheme();

  const pages: TopMenuItem[] = appPages.map(({ name, path, newTab }) => ({
    name,
    onPress: () => {
      if (newTab) {
        Linking.openURL(path);
      } else {
        navigate(path);
      }
    },
    textStyle: {
      color: selectedPage === path ? colors.primary : colors.dark1,
      fontWeight: selectedPage === path ? 'bold' : 'normal',
      fontSize: 14,
    },
    hoveredTextStyle: {
      fontWeight: selectedPage === path ? 'bold' : 'normal',
      fontSize: 14,
    },
  }));

  pages.push({
    name: 'Log out',
    onPress: () => logout?.(redirectTo),
    containerStyle: ml('auto'),
    textStyle: { color: colors.error, fontSize: 14 },
    hoveredTextStyle: { color: colors.errorDark, fontSize: 14 },
  });

  return { onLogout: logout, pages };
}
